import SiteChrome from "@chrome/SiteChrome";
import { GetStaticPaths, GetStaticProps, GetStaticPropsContext } from "next";
import { HtmlPageTitle } from "@components/HtmlPageTitle";
import { SiteHtmlPageTitle } from "@content/en/HtmlTitle";
import CommunityProjects from "@components/community/CommunityProjects";
import { MetaDescription } from "@components/MetaDescription";
import {
  allHacksterCategories,
  categoryKeyToValue,
} from "@components/community/categoryUtility";

type CommunityProjectsPageWithCategoryProps = {
  category: string;
};

const CommunityProjectsPage = ({
  category,
}: CommunityProjectsPageWithCategoryProps) => (
  <SiteChrome>
    <HtmlPageTitle title={`Projects - ${SiteHtmlPageTitle}`} />
    <MetaDescription description="A list of Hackster projects created by Blues and our community." />
    <CommunityProjects category={category} />
  </SiteChrome>
);

export const getStaticProps: GetStaticProps = async ({
  params,
}: GetStaticPropsContext) => ({
  props: {
    category: categoryKeyToValue(allHacksterCategories, `${params?.category}`),
  },
});

export const getStaticPaths: GetStaticPaths = async () => {
  const should404ForSurprisePaths = true;
  const allCategories = allHacksterCategories;
  const allPaths = allCategories.map((category) => ({
    params: { category: category.key },
  }));

  return {
    paths: allPaths,
    fallback: !should404ForSurprisePaths,
  };
};

export default CommunityProjectsPage;
